import type {
  UpdateUserPreferencesRequest,
  UpdateUserRequest,
  User,
} from '@billx/types';

import { userApiClient } from '../clients';
import type { NucleusServiceResponse, VerifyUpdateRequest } from './types';
import { handleAxiosError } from './utils';
export class UserService {
  /**
   * Fetch a single user by ID
   */
  static async fetchCurrentUser(): Promise<NucleusServiceResponse<User>> {
    try {
      const response = await userApiClient.get('/users/me');

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to fetch user');
    }
  }

  /**
   * Update a user
   */

  static async updateUser(
    userId: string,
    updateData: UpdateUserRequest
  ): Promise<
    NucleusServiceResponse<
      User & { verificationRequired?: boolean; message?: string }
    >
  > {
    try {
      const response = await userApiClient.patch<
        NucleusServiceResponse<
          User & { verificationRequired?: boolean; message?: string }
        >
      >(`/users/${userId}`, updateData);

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to update user');
    }
  }

  /**
   * Verify a user update
   */
  static async verifyUpdate(
    userId: string,
    data: VerifyUpdateRequest
  ): Promise<NucleusServiceResponse<User>> {
    try {
      const response = await userApiClient.post<NucleusServiceResponse<User>>(
        `/users/${userId}/verify-update`,
        data
      );

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to verify update');
    }
  }

  /**
   * Update a specific user preference
   */
  static async updateUserPreference(
    userId: string,
    preferences: UpdateUserPreferencesRequest
  ): Promise<NucleusServiceResponse<User>> {
    try {
      const response = await userApiClient.patch(
        `/users/${userId}/preferences`,
        preferences
      );

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to update user preference');
    }
  }

  /**
   * Update push token
   */
  static async updatePushToken(
    expoPushToken: string
  ): Promise<NucleusServiceResponse<{ message: string }>> {
    try {
      const response = await userApiClient.post('/user/users/push-token', {
        expoPushToken,
      });

      return response.data;
    } catch (error) {
      return handleAxiosError(error, 'Failed to update push token');
    }
  }
}
